export default __webpack_public_path__ + "static/media/bookStock.6ae1dc69.png";